<div class="about-container" #rootElement>
    <div class="container">
        <div class="row">
            <div class="col-12" [innerHTML]="principalDescripcion">
                
            </div>
        </div>
    </div>
</div>